/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener('DOMContentLoaded', function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});

document.addEventListener('change', function(event) {
  if (!event.target.matches('.home-product-card__variant-pills .color-swatch__radio')) {
    return;
  }

  var productItem = event.target.closest('product-item');
  if (!productItem) {
    return;
  }

  var variantId = event.target.getAttribute('data-variant-id');
  var form = productItem.querySelector('.home-product-card__atc-form');

  if (form && variantId) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variantId;
    }
  }

  // Update the displayed price + compare-at for the selected variant.
  var priceValue = productItem.querySelector('.home-product-card__price-value');
  if (priceValue) {
    var priceDisplay = event.target.getAttribute('data-price-display');
    if (priceDisplay) {
      priceValue.textContent = priceDisplay;
    }

    var compareDisplay = event.target.getAttribute('data-compare-display');
    var compareEl = productItem.querySelector('.home-product-card__price-compare');
    if (compareEl) {
      if (compareDisplay) {
        compareEl.textContent = compareDisplay;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    priceValue.classList.toggle('home-product-card__price-value--sale', !!compareDisplay);
  }
});

function setHomeVariantPillMoreCount(buttons, hiddenCount) {
  var shouldShow = hiddenCount > 0;

  buttons.forEach(function(button) {
    var countNode = button.querySelector('[data-home-variant-pill-more-count]');

    if (countNode) {
      countNode.textContent = hiddenCount;
    }

    button.classList.toggle('is-hidden', !shouldShow);

    if (shouldShow) {
      button.removeAttribute('hidden');
    } else {
      button.setAttribute('hidden', '');
    }
  });
}

function getHomeVariantPillsGap(pillsContainer) {
  var gap = parseFloat(getComputedStyle(pillsContainer).columnGap);

  if (Number.isNaN(gap)) {
    gap = parseFloat(getComputedStyle(pillsContainer).gap);
  }

  return Number.isNaN(gap) ? 4 : gap;
}

function sumHomeVariantPillWidths(pillWidths, visibleCount, gap) {
  var total = 0;

  for (var i = 0; i < visibleCount; i++) {
    total += pillWidths[i];

    if (i > 0) {
      total += gap;
    }
  }

  return total;
}

function getHomeVariantPillMoreWidth(moreButtons, hiddenCount) {
  if (!moreButtons.length || hiddenCount <= 0) {
    return 0;
  }

  setHomeVariantPillMoreCount(moreButtons, hiddenCount);

  for (var i = 0; i < moreButtons.length; i++) {
    if (moreButtons[i].offsetWidth > 0) {
      return moreButtons[i].offsetWidth;
    }
  }

  return 28;
}

function fitHomeVariantPillsRow(row) {
  var pillsContainer = row.querySelector('.home-product-card__variant-pills');
  if (!pillsContainer) {
    return;
  }

  var pills = Array.from(pillsContainer.querySelectorAll('[data-home-variant-pill]'));
  var moreButtons = Array.from(pillsContainer.querySelectorAll('[data-home-variant-pill-more]'));

  if (!pills.length) {
    pillsContainer.classList.add('is-measured');
    return;
  }

  pills.forEach(function(pill) {
    pill.hidden = false;
  });
  setHomeVariantPillMoreCount(moreButtons, 0);

  var gap = getHomeVariantPillsGap(pillsContainer);
  var containerWidth = pillsContainer.clientWidth;
  var pillWidths = pills.map(function(pill) {
    return pill.offsetWidth;
  });
  var allPillsWidth = sumHomeVariantPillWidths(pillWidths, pills.length, gap);
  var chosenVisibleCount = pills.length;
  var hiddenCount = 0;

  if (allPillsWidth > containerWidth + 1) {
    chosenVisibleCount = 0;

    if (moreButtons.length) {
      for (var visibleCount = pills.length - 1; visibleCount >= 0; visibleCount--) {
        hiddenCount = pills.length - visibleCount;

        if (hiddenCount <= 0) {
          continue;
        }

        var pillsWidth = sumHomeVariantPillWidths(pillWidths, visibleCount, gap);
        var moreWidth = getHomeVariantPillMoreWidth(moreButtons, hiddenCount);
        var totalWidth = pillsWidth + (visibleCount > 0 ? gap : 0) + moreWidth;

        if (totalWidth <= containerWidth + 1) {
          chosenVisibleCount = visibleCount;
          break;
        }
      }
    } else {
      for (var fallbackVisibleCount = pills.length; fallbackVisibleCount >= 0; fallbackVisibleCount--) {
        if (sumHomeVariantPillWidths(pillWidths, fallbackVisibleCount, gap) <= containerWidth + 1) {
          chosenVisibleCount = fallbackVisibleCount;
          break;
        }
      }
    }
  }

  hiddenCount = pills.length - chosenVisibleCount;

  pills.forEach(function(pill, index) {
    pill.hidden = index >= chosenVisibleCount;
  });
  setHomeVariantPillMoreCount(moreButtons, hiddenCount);
  pillsContainer.classList.add('is-measured');
}

function fitAllHomeVariantPills(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-home-variant-pills]').forEach(fitHomeVariantPillsRow);
}

var homeVariantPillsResizeObserver;

function initHomeVariantPills() {
  fitAllHomeVariantPills();

  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', function() {
      fitAllHomeVariantPills();
    });
    return;
  }

  if (!homeVariantPillsResizeObserver) {
    homeVariantPillsResizeObserver = new ResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        var row = entry.target.closest('[data-home-variant-pills]');
        if (row) {
          fitHomeVariantPillsRow(row);
        }
      });
    });
  }

  document.querySelectorAll('[data-home-variant-pills] .home-product-card__variant-pills').forEach(function(container) {
    if (container.dataset.homeVariantPillsObserved === 'true') {
      return;
    }

    homeVariantPillsResizeObserver.observe(container);
    container.dataset.homeVariantPillsObserved = 'true';
  });
}

document.addEventListener('DOMContentLoaded', initHomeVariantPills);
document.addEventListener('shopify:section:load', function(event) {
  initHomeVariantPills();
  if (event.target) {
    fitAllHomeVariantPills(event.target);
  }
});
/* ---------------------------------------------------------------------------
   Stack-pieces "Subscribe & Save 15%" — open the Klaviyo signup pop-up on every
   Add to Cart when the Subscribe & Save option is selected.

   The pop-up is a dedicated Klaviyo form set to "Only on a custom trigger" (it
   never auto-displays), so opening it here does not interfere with any other
   Klaviyo form, and we open it via the documented openForm command. Before each
   open we clear ONLY this form's own frequency record from Klaviyo's onsite
   storage so it can reshow on every add to cart; other forms' records (e.g. the
   normal on-load pop-up) are left untouched. The item is added by the normal
   AJAX product form, so it stays in the cart even if the shopper closes the pop-up.

   Scoped by <subscribe-save data-enabled="true" data-form-id="...">, rendered
   only on the stack-pieces template with the product metafield on.
--------------------------------------------------------------------------- */
(function () {
  // Remove only this form's view/close record so Klaviyo will reopen it again.
  function resetFormFrequency(formId) {
    if (!formId) return;
    try {
      var raw = window.localStorage.getItem('klaviyoOnsite');
      if (!raw) return;
      var data = JSON.parse(raw);
      var modal = data && data.viewedForms && data.viewedForms.modal;
      if (!modal) return;
      if (modal.disabledForms) delete modal.disabledForms[formId];
      if (modal.viewedForms) delete modal.viewedForms[formId];
      if (modal.disabledTeasers) delete modal.disabledTeasers[formId];
      window.localStorage.setItem('klaviyoOnsite', JSON.stringify(data));
    } catch (e) {}
  }

  function openKlaviyoForm(formId) {
    if (!formId) return;
    resetFormFrequency(formId);
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    } catch (e) {}
  }

  // Remember, per browser, that this shopper already submitted the form, so we
  // don't prompt them again on later add-to-carts.
  function storageKey(formId) {
    return 'stackSubscribeDone:' + formId;
  }
  function hasSubmitted(formId) {
    try {
      return window.localStorage.getItem(storageKey(formId)) === '1';
    } catch (e) {
      return false;
    }
  }
  function markSubmitted(formId) {
    try {
      window.localStorage.setItem(storageKey(formId), '1');
    } catch (e) {}
  }

  function initStackSubscribeSave() {
    var el = document.querySelector('subscribe-save[data-enabled="true"]');
    if (!el || el.dataset.ssInit === 'true') return;
    el.dataset.ssInit = 'true';

    var formId = (el.getAttribute('data-form-id') || '').trim();
    var productId = (el.getAttribute('data-product-id') || '').trim();

    // When the shopper submits the Klaviyo form, remember it so we stop
    // re-opening the pop-up for them. Klaviyo dispatches `klaviyoForms` events
    // with a `type` and the `formId` that fired them.
    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail;
      if (!detail || detail.type !== 'submit') return;
      if (formId && detail.formId && detail.formId !== formId) return;
      markSubmitted(formId);
    });

    // Keep the selected visual state in sync with the radios.
    el.addEventListener('change', function (event) {
      if (!event.target || event.target.name !== 'stack-subscribe-option') return;
      el.querySelectorAll('.stack-subscribe__option').forEach(function (option) {
        var input = option.querySelector('.stack-subscribe__input');
        option.classList.toggle('stack-subscribe__option--selected', !!(input && input.checked));
      });
    });

    function subscribeSelected() {
      var checked = el.querySelector('input[name="stack-subscribe-option"]:checked');
      return !!checked && checked.value === 'subscribe';
    }

    // Fire when the stack itself is added to cart. We scope to this product by
    // comparing the added line item's product_id, so the "Buy Individually"
    // quick-buy adds (other products) don't open the pop-up.
    document.addEventListener('variant:added', function (event) {
      if (!subscribeSelected()) return;

      // Already signed up on this browser — don't prompt again.
      if (hasSubmitted(formId)) return;

      if (productId) {
        var added = event && event.detail && event.detail.variant;
        var addedProductId = added && (added.product_id || added.product_id === 0) ? String(added.product_id) : '';
        if (addedProductId && addedProductId !== productId) return;
      }

      openKlaviyoForm(formId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStackSubscribeSave);
  } else {
    initStackSubscribeSave();
  }
})();
